<template>
    <label :for="title" class="form__checkbox form__checkbox--small"
           @click="click">

        <input @change="change" type="checkbox" :id="title"
               :name="title" v-model="isActive"
        >

        <span class="checkmark checkmark--checkbox"></span>
        {{ title }}
        <span v-if="totalCount !== null">

        </span>
<!--        {{ totalCount !== null ? `(${$filters.formatNumber(totalCount)})` : '' }}-->

    </label>
</template>
<script>
import {useStore} from "vuex";
import {getCurrentInstance, ref, watchEffect, computed} from 'vue'

export default {
    name: "FilterItem",
    props: ['title', 'slug', 'total', 'active'],
    setup(props) {
        const store = useStore()
        const instance = getCurrentInstance()
        const isActive = ref(props.active);
        const has = ref(props.active);
        const totalCount = computed(() => {
            let item = store.getters.aggregatesData[`${instance.parent.props.slug}.${instance.props.slug}`];

            if(item) {
                return item;
            }

            return 0;
        });

        /**
         * Uncheck and check filter is it exists in the activeFilters state
         */
        watchEffect(() => {
            let item = null
            switch (instance.parent.props.slug) {
                case 'category':
                    item = store.getters.activeCategories.find(item => item === props.slug)
                    break;
                case 'celeb':
                    item = store.getters.activeChefs.find(item => item === props.slug)
                    break;
                case 'program':
                    item = store.getters.activePrograms.find(item => item === props.slug)
                    break;
                case 'blog':
                    item = store.getters.activeBlog.find(item => item === props.slug)
                    break;
            }
            isActive.value = !!item
        })

        return {
            isActive,
            totalCount,
            change: () => {
                const obj = {
                    active: isActive.value,
                    title: props.title,
                    slug: props.slug,
                }

                switch (instance.parent.props.slug) {
                    case 'category':
                        store.dispatch('updateCategory', obj)
                        break;
                    case 'celeb':
                        store.dispatch('updateChef', obj)
                        break;
                    case 'program':
                        store.dispatch('updateProgram', obj)
                        break;
                    case 'blog':
                        store.dispatch('updateBlog', obj)
                        break;
                }
            }
        }
    },

}

</script>
[
"category.aperitief" => 35,
"category.bijgerecht" => 35,
"category.hoofdgerecht" => 35,
"category.lunch" => 35,
...
]